var strokeImages45lb = {
    "1": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-1-1.png?v=1744928036", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-1.pdf?v=1737742298" },
    "2": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-2-1.png?v=1744928036", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-2.pdf?v=1737742298" },
    "3": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-3-1.png?v=1744928036", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-3.pdf?v=1737742298" },
    "4": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-4-1.png?v=1744928036", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-4.pdf?v=1737742298" },
    "5": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-5-1.png?v=1744928036", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-5.pdf?v=1737742298" },
    "6": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-6-1.png?v=1744928036", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-6.pdf?v=1737742298" },
    "8": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-8-1.png?v=1744928036", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-8.pdf?v=1737742298" },
    "9": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-9-1.png?v=1744928036", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-9.pdf?v=1737742298" },
    "10": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-10-1.png?v=1744928036", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-10.pdf?v=1737742298" },
    "12": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-12-1.png?v=1744928036", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-12.pdf?v=1737742298" },
    "14": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-14-1.png?v=1744928036", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-14.pdf?v=1737742298" },
    "16": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-16-1.png?v=1744928036", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-16.pdf?v=1737742298" },
    "18": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-18-1.png?v=1744928036", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-18.pdf?v=1737742298" },
    "22": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-22-1.png?v=1744928036", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-22.pdf?v=1737742298" },
    "24": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-24-1.png?v=1744928036", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-24.pdf?v=1737742298" },
    "28": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-28-1.png?v=1744928036", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-28.pdf?v=1737742298" },
    "30": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-30-1.png?v=1744928036", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-45-12-30.pdf?v=1737742298" }
  };
  var strokeImages135lb = {
    "1": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-1.png?v=1744930355", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-1.pdf?v=1737742790" },
    "2": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-2.png?v=1744930355", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-2.pdf?v=1737742790" },
    "3": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-3.png?v=1744930355", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-3.pdf?v=1737742790" },
    "4": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-4.png?v=1744930355", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-4.pdf?v=1737742790" },
    "5": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-5.png?v=1744930355", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-5.pdf?v=1737742790" },
    "6": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-6.png?v=1744930355", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-6.pdf?v=1737742790" },
    "8": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-8.png?v=1744930355", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-8.pdf?v=1737742790" },
    "9": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-9.png?v=1744930355", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-9.pdf?v=1737742790" },
    "10": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-10.png?v=1744930355", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-10.pdf?v=1737742790" },
    "12": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-12.png?v=1744930355", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-12.pdf?v=1737742790" },
    "14": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-14.png?v=1744930355", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-14.pdf?v=1737742790" },
    "16": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-16.png?v=1744930355", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-16.pdf?v=1737742790" },
    "18": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-18.png?v=1744930355", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-18.pdf?v=1737742790" },
    "22": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-22.png?v=1744930355", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-22.pdf?v=1737742790" },
    "24": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-24.png?v=1744930355", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-24.pdf?v=1737742790" },
    "28": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-28.png?v=1744930355", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-28.pdf?v=1737742790" },
    "30": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-30.png?v=1744930355", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-135-12-30.pdf?v=1737742790" }
  };
  var strokeImages225lb = {
    "1": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-1.png?v=1745341019", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-1.pdf?v=1737743376" },
    "2": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-2.png?v=1745341020", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-2.pdf?v=1737743376" },
    "3": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-3.png?v=1745341020", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-3.pdf?v=1737743376" },
    "4": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-4.png?v=1745341020", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-4.pdf?v=1737743376" },
    "5": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-5.png?v=1745341020", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-5.pdf?v=1737743376" },
    "6": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-6.png?v=1745341020", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-6.pdf?v=1737743376" },
    "8": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-8.png?v=1745341020", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-8.pdf?v=1737743376" },
    "9": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-9.png?v=1745341020", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-9.pdf?v=1737743376" },
    "10": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-10.png?v=1745341020", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-10.pdf?v=1737743376" },
    "12": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-12.png?v=1745341020", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-12.pdf?v=1737743376" },
    "14": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-14.png?v=1745341020", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-14.pdf?v=1737743376" },
    "16": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-16.png?v=1745341020", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-16.pdf?v=1737743376" },
    "18": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-18.png?v=1745341020", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-18.pdf?v=1737743376" },
    "22": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-22.png?v=1745341020", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-22.pdf?v=1737743376" },
    "24": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-24.png?v=1745341020", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-24.pdf?v=1737743376" },
    "28": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-28.png?v=1745341020", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-28.pdf?v=1737743376" },
    "30": { img: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-30.png?v=1745341020", link: "https://cdn.shopify.com/s/files/1/0615/2193/files/FA-C-225-12-30.pdf?v=1737743376" }
  }

  jQuery(document).ready(function ($) {
    // Image handling
    const strokeSelector = document.getElementById("strokeSelector");
    const forceSelector = document.getElementById("forceSelector");
    const strokeImage = document.getElementById("strokeImage");
    const imageLink = document.getElementById("imageLink");

    function updateImage() {
      const stroke = strokeSelector?.value;
      const force = forceSelector?.value;
    
      let selectedMap = null;
      if (force === "45") selectedMap = strokeImages45lb;
      else if (force === "135") selectedMap = strokeImages135lb;
      else if (force === "225") selectedMap = strokeImages225lb;
    
      if (selectedMap && selectedMap[stroke]) {
        strokeImage.src = selectedMap[stroke].img;
        imageLink.href = selectedMap[stroke].link;
      }
    }

    function preloadImages(map) {
      Object.values(map).forEach(entry => {
        const img = new Image();
        img.src = entry.img;
      });
    }
    
    window.addEventListener('load', () => {
      setTimeout(() => {
        preloadImages(strokeImages45lb);
        preloadImages(strokeImages135lb);
        preloadImages(strokeImages225lb);
      }, 500);
    });

    strokeSelector?.addEventListener("change", updateImage);
    forceSelector?.addEventListener("change", updateImage);

    // Dropdown toggles
    function bindDropdownListeners() {
    const dropdownToggles = document.querySelectorAll(".dropdown-trigger");
    dropdownToggles.forEach(trigger => {
      if (!trigger.dataset.listenerAdded) {
        trigger.dataset.listenerAdded = "true";
        trigger.addEventListener("click", () => {
        const detailsSection = trigger.nextElementSibling;
        if (detailsSection) {
          detailsSection.style.transition = "max-height 0.3s ease, padding 0.3s ease";

          if (detailsSection.classList.contains("open")) {
            // Close
            detailsSection.style.maxHeight = "0px";
            detailsSection.classList.remove("open");
          } else {
            // Open
            detailsSection.style.maxHeight = detailsSection.scrollHeight + "px";
            detailsSection.classList.add("open");

            // If content includes images, re-measure once they load
            detailsSection.querySelectorAll("img").forEach(img => {
              if (!img.complete) {
                img.addEventListener("load", () => {
                  if (detailsSection.classList.contains("open")) {
                    detailsSection.style.maxHeight = detailsSection.scrollHeight + "px";
                  }
                });
              }
            });
          }
        }
      });
      }
    });
  }

    // Product tab toggle
    let lastChecked = document.querySelector("input[type='radio'][name='productTabs']");
    document.querySelectorAll("input[type='radio'][name='productTabs']").forEach(radio => {
      radio.addEventListener("click", function () {
        if (lastChecked === this) {
          this.checked = false;
          lastChecked = null;
        } else {
          lastChecked = this;
        }
      });
    });

    // MutationObserver to track dynamic elements
    const contentTarget = document.querySelector(".fg-product-additional-content");
    if (contentTarget) {
      const contentObserver = new MutationObserver(() => {
        bindDropdownListeners();
        hideNearestH2Above(".site-wrapper");
        setupYouTubeThumbnails();
      });
      contentObserver.observe(contentTarget, { childList: true, subtree: true });
    }

    // Function to hide nearest <h2> above a target
    function hideNearestH2Above(selector) {
      const element = document.querySelector(selector);
      if (!element) return;

      let h2 = element.previousElementSibling;
      while (h2 && h2.tagName !== "H2") {
        h2 = h2.previousElementSibling;
      }

      if (h2) h2.style.display = "none";
    }

    function setupYouTubeThumbnails() {
      var youtube = document.querySelectorAll(".youtubeVideo:not([data-initialized])");
      youtube.forEach(el => {
        el.dataset.initialized = "true";
        el.addEventListener("click", function () {
          var iframe = document.createElement("iframe");
          iframe.setAttribute("frameborder", "0");
          iframe.setAttribute("allowfullscreen", "");
          iframe.setAttribute("allow", "autoplay");
          iframe.setAttribute("src", "https://www.youtube.com/embed/" + this.dataset.embed + "?rel=0&showinfo=0&autoplay=1");
          this.innerHTML = "";
          this.appendChild(iframe);
        });
      });
    }



    // Initial bindings
    bindDropdownListeners();
    hideNearestH2Above(".site-wrapper");
    setupYouTubeThumbnails();
  });

